const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de creación de ordenes',
  PAGE_DESCRIPTION:
    'En este apartado puedes crear una orden o muchas ordenes, utiliza el formulario o selecciona un archivo CSV para cargar las ordenes de acuerdo a lo que necesites.'
};

export default HELPER_TEXTS;
